module.exports = __webpack_public_path__ + "static/media/seedling.56973105.svg";